"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _Modal = require("@ccw-pwa-ui/Modal");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _react = _interopRequireDefault(require("react"));
var _Button = require("@ccw-pwa-ui/Button");
require("../../styles/SensorPlacementComponent.css");
var _images = _interopRequireDefault(require("../../common_features/assets/images"));
const SensorPlacementComponent = _ref => {
  let {
    navHeading,
    rightNavHeading,
    handleCancle,
    handleBack,
    headerText,
    handleClick,
    subContent,
    bottomBtnTitle,
    sensorBtnDisable,
    sensorImage,
    handleOptionData,
    options,
    selectedOption,
    modalData,
    isUpdating
  } = _ref;
  return isUpdating ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "sensor-placement-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    rightNavHeading: rightNavHeading,
    handleCancle: handleCancle,
    handleBack: handleBack,
    leftArrowImage: _images.default.leftArrow.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sensor-placement-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sensor-placement-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sensor-placement-heading"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "sensor-placement-subContent"
  }, subContent), /*#__PURE__*/_react.default.createElement("div", {
    className: "sensor-placement-image-div"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: sensorImage,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "sensor-placement-btn-selectdiv"
  }, options === null || options === void 0 ? void 0 : options.map((option, index) => /*#__PURE__*/_react.default.createElement("button", {
    key: "".concat(option),
    "data-testid": "sensor-placement-btn",
    className: "selectedOptions ".concat(option === selectedOption ? "selected" : ""),
    onClick: e => handleOptionData(e, option)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "btn-select-content"
  }, option), /*#__PURE__*/_react.default.createElement("div", {
    className: "selectedOuter ".concat(option === selectedOption ? "selected" : "")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "selectedInner ".concat(option === selectedOption ? "show" : "")
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "sensor-placement-btn",
    "data-testid": "sensor-placement-button"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: () => handleClick(),
    variant: "primary-long",
    title: bottomBtnTitle,
    disabled: sensorBtnDisable
  })))), (modalData === null || modalData === void 0 ? void 0 : modalData.displayModal) && /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: modalData === null || modalData === void 0 ? void 0 : modalData.displayModal,
    modalHeaderText: modalData === null || modalData === void 0 ? void 0 : modalData.modalHeaderText,
    modalHeaderTextStyle: modalData === null || modalData === void 0 ? void 0 : modalData.modalHeaderTextStyle,
    modalDetailText: modalData === null || modalData === void 0 ? void 0 : modalData.modalDetailText,
    modalHeaderIcon: modalData === null || modalData === void 0 ? void 0 : modalData.modalHeaderIcon,
    displayCrossIcon: modalData === null || modalData === void 0 ? void 0 : modalData.displayCrossIcon,
    variant: modalData === null || modalData === void 0 ? void 0 : modalData.variant,
    positiveActionButtonTitle: modalData === null || modalData === void 0 ? void 0 : modalData.positiveActionButtonTitle,
    positiveAction: modalData === null || modalData === void 0 ? void 0 : modalData.positiveAction,
    negativeButtonActionTitle: modalData === null || modalData === void 0 ? void 0 : modalData.negativeButtonActionTitle,
    crossIconAction: modalData === null || modalData === void 0 ? void 0 : modalData.crossIconAction,
    negativeAvtion: modalData === null || modalData === void 0 ? void 0 : modalData.negativeAvtion
  })));
};
var _default = exports.default = SensorPlacementComponent;